module.exports = __webpack_public_path__ + "img/Paris Bingo.fc237e60.jpeg";